export default "__VITE_ASSET__BCruR1y___"